import React from "react";
import About from "./pages/About";
import Contact from "./pages/Contact"; 
import TeachersSection from "./pages/Teachers";
import Card from "./components/Card"; 
import Partners from "./components/Partners";
import WhatsappButton from "./components/WhatsappButton";
import Carrossel from "./components/Carrossel";
import Events from "./components/Blog";
import FAQ from "./pages/FAQ";
import GymPlans from "./pages/GymPlans";
import Maps from "./components/Maps";
import Agendamento from "./components/Agendamento";
import InstagramSection from "./components/InstagramSection";
import "./styles/home.css"; 
import TrabalheConosco from "./pages/WorkWithUs";
import BlogPostPage from "./pages/BlogPostPage";
import BlogList from "./pages/BlogList";

const Home = () => {
  return (
    <div>
      <div className="home-content">
        

        <Carrossel /> 
  

        {/* Conteúdo About */}
        <About />
        <GymPlans />
        <FAQ />

        {/* <BlogList /> */}
        <Events />
        {/* Conteúdo Contact */}
        <Contact />
        <TrabalheConosco />

        <InstagramSection />

        {/* <Maps /> */}
      </div>
    </div>
  );
};

export default Home;
